export const ceiling = {
    title: '装配式吊顶解决方案',
    description: '一种天花造型，无惧顶面变化，都能灵活适配',
    contactNow: '立即咨询',
    firstTitle: '三维造型能力',
    firstDescription:
        '基于拉伸、扫掠、布尔等几何建模能力，快速完成产品造型；支持解析CAD图形轮廓进行二次应用',
    secondTitle: '参数化建模',
    secondDescription:
        '绘制图形轮廓、装配三维造型，用参数配置出造型的变化规则；建立尺寸、材质等参数的约束规则，实现参数关联变化',
    thirdTitle: '装配式DIY',
    thirdDescription: '随心自由拼搭造型，实现部件之间的精准适配与联动',
    fourthTitle: '高效设计',
    fourthDescription:
        '构建企业专属产品造型库，无限复用，提高设计效率；使用时简单调参，即可获得不同尺寸、样式的产品造型',
    fiveTitle: '全链路流转',
    fiveDescription:
        '从后台建模到设计应用、生成图纸、算量报价、对接外部系统全链路打通',
    fiveAddDescription: '*图纸、算量报价正在开发中，敬请期待',
};
